export default __webpack_public_path__ + "static/media/security-details-invite-investors.93551321.svg";